/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import domainResources from '../configuration/apiDomain.json';
import HttpHeader from '../shared/httpheader';

class APIEndpoints {
  constructor() {
    this.apiDomain = '';
    this.loginResource = '';
    this.memberSummaryResource = '';
    this.memberCoverageSummaryResource = '';
    this.memberextcoveragesummary = '';
    this.coverageDetailConfiguration = '';
    this.memberAccumulatorResource = '';
    this.memberCoverageAccumsResource = '';
    this.claimStatusSummaryReource = '';
    this.claimStatusSummaryByProductResource = '';
    this.spendingSummaryResource = '';
    this.claimsListResource = '';
    this.claimslistFamilyTabsResource = '';
    this.claimDetailsResource = '';
    this.coveredServicesCostResource = '';
    this.myProfileDetailsResource = '';
    this.accountDetailsResource = '';
    this.sendEmailResource = '';
    this.memberAddressDetails = '';
    this.dependentAddressDetails = '';
    this.enrollmentAddMemberAddressDetails = '';
    this.enrollmentAddDependentAddressDetails = '';
    this.memberContactDetails = '';
    this.dependentContactDetails = '';
    this.logoutResource = '';
    this.getOtpGenerate = '';
    this.getOtpVerify = '';
    this.getKeyStore = '';
    this.encryptionKey = '';
    this.getUser = '';
    this.postValidateMemberInfo = '';
    this.forgotPasswordVerify = '';
    this.updateUserResource = '';
    this.updateUserResourceWithoutApproval = '';
    this.updateEOBPreference = '';
    this.checkUserResource = '';
    this.addUserResource = '';
    this.getComparedRequest = '';
    this.relationships = '';
    this.EOB = '';
    this.getIdCard = '';
    this.planYearPeriod = '';
    this.getuserIdCard = '';
    this.allEmrollmentConfigList = '';
    this.enrollmentMemberCoveragePlans = '';
    this.enrollmentClientConfig = '';
    this.enrollmentAllowableCoverages = '';
  }

  getAPIDomain() {
    this.apiDomain = `https://${HttpHeader.getCNAME()}.${HttpHeader.getDomainName()}/apigw/v1`;
    //this.apiDomain = 'https://centivo-test.mphasishealthportal.com/apigw/v1';
    return this.apiDomain;
  }

  getHippaPermissions() {
    return this.getAPIDomain() + domainResources.GET_HIPPA_PERMISSIONS;
  }
  getHippaPermissionsRights() {
    return this.getAPIDomain() + domainResources.GET_HIPPA_PERMISSIONS_RIGHTS;
  }
  updateHippaPermissionsRights() {
    return (
      this.getAPIDomain() + domainResources.GET_HIPPA_PERMISSIONS_RIGHTS_UPDATES
    );
  }

  getHippaPermissionsEmployee() {
    return this.getAPIDomain() + domainResources.GET_HIPPA_PERMISSIONS_EMPLOYEE;
  }

  getHippaPermissionsDependent() {
    return (
      this.getAPIDomain() + domainResources.GET_HIPPA_PERMISSIONS_DEPENDENT
    );
  }

  getKeyStoreResources() {
    this.getKeyStore = domainResources.GET_KEY_STORE_RESOURCE;
    return this.getAPIDomain() + this.getKeyStore;
  }

  getEncryptionKeyResources() {
    this.encryptionKey = domainResources.GET_ENCRYPTION_KEY_RESOURCE;
    return this.getAPIDomain() + this.encryptionKey;
  }

  getAdminConfigResources() {
    this.getAdminConfig = domainResources.GET_ADMIN_CONFIG_RESOURCE;
    return this.getAPIDomain() + this.getAdminConfig;
  }

  getLoginResource() {
    this.loginResource = domainResources.LOGIN_RESOURCE;
    return this.getAPIDomain() + this.loginResource;
  }

  getMemberSummaryResource() {
    this.memberSummaryResource = domainResources.MEMBER_SUMMARY_RESOURCE;
    return this.getAPIDomain() + this.memberSummaryResource;
  }
  isApprovalRequestPendingForMemberResource() {
    this.isApprovalRequestPendingForMember =
      domainResources.IS_APPROVAL_REQUEST_PENDING_FOR_MEMBER;
    return this.getAPIDomain() + this.isApprovalRequestPendingForMember;
  }

  getMemberCoverageSummaryResource() {
    this.memberCoverageSummaryResource =
      domainResources.MEMBER_COVERAGE_SUMMARY_RESOURCE;
    return this.getAPIDomain() + this.memberCoverageSummaryResource;
  }
  getMemberExtCoverageSummaryResource() {
    this.memberExtCoverageSummary =
      domainResources.MEMBER_EXTCOVERAGE_SUMMARY_RESOURCE;
    return this.getAPIDomain() + this.memberExtCoverageSummary;
  }
  getMemberCoveragePlan() {
    this.memberCoveragePlan = domainResources.MEMBER_COVERAGE_PLAN;
    return this.getAPIDomain() + this.memberCoveragePlan;
  }
  getMemberCoveragePlanProducts() {
    this.enrollmentMemberCoveragePlans =
      domainResources.ENROLLMENT_MEMBER_COVERAGE_PLANS;
    return this.getAPIDomain() + this.enrollmentMemberCoveragePlans;
  }
  getCoverageDetailConfiguration() {
    this.coverageDetailConfiguration =
      domainResources.MEMBER_COVERAGE_DETAIL_CONFIGURATION;
    return this.getAPIDomain() + this.coverageDetailConfiguration;
  }
  getCoverageExceptionsConfiguration() {
    this.coverageExceptionsConfiguration =
      domainResources.MEMBER_COVERAGE_EXCEPTION_CONFIGURATION;
    return this.getAPIDomain() + this.coverageExceptionsConfiguration;
  }
  getMemberAccumulatorResource() {
    this.memberAccumulatorResource =
      domainResources.MEMBER_ACCUMULATOR_RESOURCE;
    return this.getAPIDomain() + this.memberAccumulatorResource;
  }

  getMemberCoverageAccumsResource() {
    this.memberCoverageAccumsResource =
      domainResources.MEMBER_COVERAGE_ACCUMS_RESOURCE;
    return this.getAPIDomain() + this.memberCoverageAccumsResource;
  }

  getClaimStatusSummaryReource() {
    this.claimStatusSummaryReource =
      domainResources.CLAIM_STATUS_SUMMARY_RESOURCE;
    return this.getAPIDomain() + this.claimStatusSummaryReource;
  }

  getClaimStatusSummaryByProductResource() {
    this.claimStatusSummaryByProductResource =
      domainResources.CLAIM_STATUS_SUMMARY_BY_PRODUCT_RESOURCE;
    return this.getAPIDomain() + this.claimStatusSummaryByProductResource;
  }

  getSpendingSummaryResource() {
    this.spendingSummaryResource = domainResources.SPENDING_SUMMARY_RESOURCE;
    return this.getAPIDomain() + this.spendingSummaryResource;
  }

  getClaimsListResource() {
    this.claimsListResource = domainResources.CLAIMS_LIST;
    return this.getAPIDomain() + this.claimsListResource;
  }

  getClaimslistFamilyTabsResource() {
    this.claimslistFamilyTabsResource = domainResources.CLAIMLIST_FAMILY_TABS;
    return this.getAPIDomain() + this.claimslistFamilyTabsResource;
  }

  getClaimDetailsResource() {
    this.claimDetailsResource = domainResources.CLAIM_DETAILS;
    return this.getAPIDomain() + this.claimDetailsResource;
  }

  getCoveredServicesCostResource() {
    this.coveredServicesCostResource = domainResources.COVERED_SERVICES_COST;
    return this.getAPIDomain() + this.coveredServicesCostResource;
  }

  getMyProfileDetailsResource() {
    this.myProfileDetailsResource = domainResources.MY_PROFILE_DETAILS;
    return this.getAPIDomain() + this.myProfileDetailsResource;
  }

  getViewMemberinformation() {
    this.viewMemberinformation = domainResources.VIEW_MEMBER_INFORMATION;
    return this.getAPIDomain() + this.viewMemberinformation;
  }

  getViewMemberinformationV2() {
    this.viewMemberinformationV2 = domainResources.VIEW_MEMBER_INFORMATION_V2;
    return this.getAPIDomain() + this.viewMemberinformationV2;
  }

  getAccountDetailsResource() {
    this.accountDetailsResource = domainResources.ACCOUNT_DETAILS;
    return this.getAPIDomain() + this.accountDetailsResource;
  }

  getSendEmailResource() {
    this.sendEmailResource = domainResources.EMAIL_SEND;
    return this.getAPIDomain() + this.sendEmailResource;
  }

  updateMemberUserAddress() {
    this.memberAddressDetails = domainResources.UPDATE_MEMBER_USER_ADDRESS;
    return this.getAPIDomain() + this.memberAddressDetails;
  }

  enrollmentAddMemberAddress() {
    this.enrollmentAddMemberAddressDetails =
      domainResources.ENROLLMENT_ADD_MEMBER_ADDRESS;
    return this.getAPIDomain() + this.enrollmentAddMemberAddressDetails;
  }

  enrollmentAddDependentAddress() {
    this.enrollmentAddDependentAddressDetails =
      domainResources.ENROLLMENT_ADD_DEPENDENT_ADDRESS;
    return this.getAPIDomain() + this.enrollmentAddDependentAddressDetails;
  }

  //update member - to update member contact api
  updateMember() {
    this.memberContactDetails = domainResources.UPDATE_MEMBER_CONTACTDETAILS;
    return this.getAPIDomain() + this.memberContactDetails;
  }

  //update dependent - to update member contact api
  updateDependent() {
    this.dependentContactDetails =
      domainResources.UPDATE_DEPENDENT_CONTACTDETAILS;
    return this.getAPIDomain() + this.dependentContactDetails;
  }

  updateDependentUserAddress() {
    this.dependentAddressDetails =
      domainResources.UPDATE_DEPENDENT_USER_ADDRESS;
    return this.getAPIDomain() + this.dependentAddressDetails;
  }

  getLogoutResource() {
    this.logoutResource = domainResources.LOGOUT_RESOURCE;
    return this.getAPIDomain() + this.logoutResource;
  }

  getOtpGenerateResources() {
    this.getOtpGenerate = domainResources.OTP_GENERATE_RESOURCE;
    return this.getAPIDomain() + this.getOtpGenerate;
  }

  getOtpGenerateResourcesEnumeration() {
    return (
      this.getAPIDomain() + domainResources.OTP_GENERATE_RESOURCE_ENUMERATION
    );
  }

  getOtpVerifyResources() {
    this.getOtpVerify = domainResources.OTP_VALIDATE_RESOURCE;
    return this.getAPIDomain() + this.getOtpVerify;
  }

  getOtpVerifyResourcesEnumaration() {
    return (
      this.getAPIDomain() + domainResources.OTP_VALIDATE_RESOURCE_ENUMERATION
    );
  }

  getPlanYearPeriod() {
    this.planYearPeriod = domainResources.PLAN_YEAR_PERIOD;
    return this.getAPIDomain() + this.planYearPeriod;
  }

  fortgotPassword() {
    this.forgotPasswordVerify = domainResources.FORGOT_PASSWORD;
    return this.getAPIDomain() + this.forgotPasswordVerify;
  }

  postValidateMemberInfoResources() {
    this.postValidateMemberInfo = domainResources.VALIDATE_MEMBER_INFO_RESOURCE;
    return this.getAPIDomain() + this.postValidateMemberInfo;
  }

  validateForgotEmail() {
    return (
      this.getAPIDomain() + domainResources.VALIDATE_MEMBER_INFO_FORGOTEMAIL
    );
  }

  dualCoverageValidateMemberInfoNewResources() {
    this.dualCoverageValidateMemberInfoNew =
      domainResources.DUAL_COVERAGE_VALIDATE_MEMBER_INFO_NEW_RESOURCE;
    return this.getAPIDomain() + this.dualCoverageValidateMemberInfoNew;
  }

  dualCoverageUpdateUserSelfAffiliationResources() {
    this.dualCoverageUpdateUserSelfAffiliation =
      domainResources.DUAL_COVERAGE_UPDATE_USER_SELF_AFFILIATION_RESOURCE;
    return this.getAPIDomain() + this.dualCoverageUpdateUserSelfAffiliation;
  }

  GetUser() {
    this.getUser = domainResources.GET_USER;
    return this.getAPIDomain() + this.getUser;
  }

  GetUserRoleAffiliationResource() {
    this.getUser = domainResources.GET_USER_ROLE_AFFILIATION;
    return this.getAPIDomain() + this.getUser;
  }

  GetRolePermissionAffiliationResource() {
    this.getUser = domainResources.GET_ROLE_PERMISSION_AFFILIATION;
    return this.getAPIDomain() + this.getUser;
  }

  UpdateUserResource() {
    this.updateUserResource = domainResources.UPDATE_USER_API_RESOURCE;
    return this.getAPIDomain() + this.updateUserResource;
  }

  UpdateUserResourceWithoutApproval() {
    this.updateUserResourceWithoutApproval =
      domainResources.UPDATE_USER_API_RESOURCE_WITHOUT_APPROVAL;
    return this.getAPIDomain() + this.updateUserResourceWithoutApproval;
  }

  AddUserResource() {
    this.addUserResource = domainResources.ADD_USER_API_RESOURCE;
    return this.getAPIDomain() + this.addUserResource;
  }

  getRequestedIDCard() {
    this.getuserIdCard = domainResources.GET_USER_ID_CARD;
    return this.getAPIDomain() + this.getuserIdCard;
  }

  checkUserExistResource() {
    this.checkUserResource = domainResources.CHECK_USER_API_RESOURCE;
    return this.getAPIDomain() + this.checkUserResource;
  }

  getRelationships() {
    this.relationships = domainResources.GET_RELATIONSHIPS;
    return this.getAPIDomain() + this.relationships;
  }

  GetMemberIdCard() {
    this.getIdCard = domainResources.GET_ID_CARD;
    return this.getAPIDomain() + this.getIdCard;
  }

  GetMemberIdCardPdf() {
    this.getIdCardPdf = domainResources.GET_ID_CARD_PDF;
    return this.getAPIDomain() + this.getIdCardPdf;
  }

  GetMemberIdCardPdfEcho() {
    return this.getAPIDomain() + domainResources.GET_ECHO_ID_CARD_PDF;
  }

  getEOB() {
    this.EOB = domainResources.GET_EOB;
    return this.getAPIDomain() + this.EOB;
  }
  getClaimAttributeDescription() {
    this.claimAttributeDescription =
      domainResources.GET_CLAIM_ATTRIBUTE_DESCRIPTION;
    return this.getAPIDomain() + this.claimAttributeDescription;
  }
  getClaimAttributeDescriptionAdjustment() {
    this.claimAttributeDescriptionAdjustment =
      domainResources.GET_CLAIM_ATTRIBUTE_DESCRIPTION_ADJUSTMENT;
    return this.getAPIDomain() + this.claimAttributeDescriptionAdjustment;
  }

  getEchoEOB() {
    return this.getAPIDomain() + domainResources.GET_ECHO_EOB;
  }

  getBranding() {
    this.GET_BRANDING = domainResources.GET_BRANDING;
    return this.getAPIDomain() + this.GET_BRANDING;
  }

  getLogo() {
    this.GET_LOGO = domainResources.GET_LOGO;
    return this.getAPIDomain() + this.GET_LOGO;
  }

  getDocument() {
    this.GET_DOCUMENT = domainResources.GET_DOCUMENT;
    return this.getAPIDomain() + this.GET_DOCUMENT;
  }

  getContact() {
    this.GET_CONTACT = domainResources.GET_CONTACT;
    return this.getAPIDomain() + this.GET_CONTACT;
  }

  getLinks() {
    this.GET_FOOTER_LINKS = domainResources.GET_FOOTER_LINKS;
    return this.getAPIDomain() + this.GET_FOOTER_LINKS;
  }

  getSocialLinks() {
    this.GET_SOCIAL_LINKS = domainResources.GET_SOCIAL_LINKS;
    return this.getAPIDomain() + this.GET_SOCIAL_LINKS;
  }

  getPageContent() {
    this.GET_PAGE_CONTENT = domainResources.GET_PAGE_CONTENT;
    return this.getAPIDomain() + this.GET_PAGE_CONTENT;
  }
  getPlanDocuments() {
    this.getDocuments = domainResources.GET_PLAN_DOCUMENTS;
    return this.getAPIDomain() + this.getDocuments;
  }
  getPlanCoverageDocument() {
    this.downloadPlanDownload = domainResources.GET_DOWNLOAD_PLAN_DOCUMENT;
    return this.getAPIDomain() + this.downloadPlanDownload;
  }
  getAllHelpCenterDocuments() {
    this.helpDocuments = domainResources.GET_HELPCENTER_DOCUMENTS;
    return this.getAPIDomain() + this.helpDocuments;
  }

  getComparedRequestId() {
    this.getComparedRequest = domainResources.GET_COMPARED_REQUEST_ID;
    return this.getAPIDomain() + this.getComparedRequest;
  }

  getCompareClaimDetails() {
    this.getComparedClaimDetailsRequest =
      domainResources.GET_COMPARED_CLAIM_DETAILS;
    return this.getAPIDomain() + this.getComparedClaimDetailsRequest;
  }
  getCoveedCost() {
    this.getCoveredCost = domainResources.GET_COVERED_COST;
    return this.getAPIDomain() + this.getCoveredCost;
  }

  getAllClaimLabelsLIst() {
    this.dashboardClaimLabels = domainResources.GET_ALL_CLAIM_LABELS_LIST;
    return this.getAPIDomain() + this.dashboardClaimLabels;
  }

  getAllNetworkList() {
    this.allNetworkList = domainResources.GET_ALL_NETWORK_LIST;
    return this.getAPIDomain() + this.allNetworkList;
  }

  getAllEnrollmentConfig() {
    this.allEmrollmentConfigList = domainResources.GET_ALL_ENROLLMENT_CONFIG;
    return this.getAPIDomain() + this.allEmrollmentConfigList;
  }

  getAdditionalPaymentDetailsResource() {
    this.claimAdditioanlPaymentDetailsResource =
      domainResources.CLAIM_ADDITIOANL_PAYMENT_DETAILS;
    return this.getAPIDomain() + this.claimAdditioanlPaymentDetailsResource;
  }

  getEnrollClientConfig() {
    this.enrollmentClientConfig = domainResources.ENROLLMENT_CLIENT_CONFIG;
    return this.getAPIDomain() + this.enrollmentClientConfig;
  }
  getAllowableCoverages() {
    this.enrollmentAllowableCoverages =
      domainResources.ENROLLMENT_GET_ALLOWABLE_COVERAGES;
    return this.getAPIDomain() + this.enrollmentAllowableCoverages;
  }

  resetDomainResources() {
    this.apiDomain = '';
    this.loginResource = '';
    this.encryptionKey = '';
    this.memberSummaryResource = '';
    this.memberCoverageSummaryResource = '';
    this.memberextcoveragesummary = '';
    this.coverageDetailConfiguration = '';
    this.memberAccumulatorResource = '';
    this.memberCoverageAccumsResource = '';
    this.claimStatusSummaryReource = '';
    this.claimStatusSummaryByProductResource = '';
    this.spendingSummaryResource = '';
    this.claimsListResource = '';
    this.claimslistFamilyTabsResource = '';
    this.claimDetailsResource = '';
    this.coveredServicesCostResource = '';
    this.myProfileDetailsResource = '';
    this.accountDetailsResource = '';
    this.sendEmailResource = '';
    this.memberAddressDetails = '';
    this.dependentAddressDetails = '';
    this.enrollmentAddMemberAddressDetails = '';
    this.enrollmentAddDependentAddressDetails = '';
    this.memberContactDetails = '';
    this.dependentContactDetails = '';
    this.logoutResource = '';
    this.getOtpGenerate = '';
    this.getOtpVerify = '';
    this.getUser = '';
    this.postValidateMemberInfo = '';
    this.updateUserResource = '';
    this.updateUserResourceWithoutApproval = '';
    this.updateEOBPreference = '';
    this.checkUserResource = '';
    this.addUserResource = '';
    this.relationships = '';
    this.EOB = '';
    this.getIdCard = '';
    this.getuserIdCard = '';
    this.allEmrollmentConfigList = '';
  }

  //get doctor name suggestions
  getDoctorNameSuggestions() {
    return this.getAPIDomain() + domainResources.GET_DOCTOR_NAME_SUGGESTIONS;
  }

  //get doctor type suggestions
  getDoctorTypeSuggestions() {
    return this.getAPIDomain() + domainResources.GET_DOCTOR_TYPE_SUGGESTIONS;
  }

  //get procedure code
  getProcedureCodes() {
    return this.getAPIDomain() + domainResources.GET_PROCEDURE_CODES;
  }

  //searchDoctors get request
  searchDoctors() {
    return this.getAPIDomain() + domainResources.SEARCH_DOCTORS;
  }

  //Upgraded : searchDoctors get request
  searchDoctorsUpgraded() {
    return this.getAPIDomain() + domainResources.SEARCH_DOCTORS_UPGRADED;
  }

  //request to get networks list related to loggedin user's plans
  getNetworksList() {
    return this.getAPIDomain() + domainResources.GET_USER_PLAN_NETWORKS_LIST;
  }

  //get Network/Tier Data for Price Compare
  getNetworkTierPriceCompareData() {
    return this.getAPIDomain() + domainResources.GET_NETWORK_TIER_DATA;
  }

  //request to get health procedure codes list
  getHealthProcedureCodes() {
    return this.getAPIDomain() + domainResources.HEALTH_PROCEDURE_CODES;
  }

  //request to get networks list related to loggedin user's plans
  getDoctorFiltersList() {
    return this.getAPIDomain() + domainResources.SEARCH_DOCTORS_FILTERS;
  }

  //request doctor details
  getDoctorDetails() {
    return this.getAPIDomain() + domainResources.GET_DOCTOR_DETAILS;
  }

  //request doctor details
  getFacilityAffiliatedDoctorsDetails() {
    return this.getAPIDomain() + domainResources.GET_AFFILIATED_DOCTORS_LIST;
  }
  //get facilty name suggestions
  getFacilityNameSuggestions() {
    return this.getAPIDomain() + domainResources.GET_FACILITY_NAME_SUGGESTIONS;
  }

  //get facilty type suggestions
  getFacilityTypeSuggestions() {
    return this.getAPIDomain() + domainResources.GET_FACILITY_TYPE_SUGGESTIONS;
  }

  //searchFacilities get request
  searchFacilities() {
    return this.getAPIDomain() + domainResources.SEARCH_FACILITIES;
  }

  //Upgraded: searchFacilities get request
  searchFacilitiesUpgraded() {
    return this.getAPIDomain() + domainResources.SEARCH_FACILITIES_UPGRADED;
  }

  getFacilityFiltersList() {
    return this.getAPIDomain() + domainResources.SEARCH_FACILITY_FILTERS;
  }

  //request for getting recent request price compare list
  getPriceCompareRecentSearchList() {
    return (
      this.getAPIDomain() + domainResources.GET_PRICE_COMPARE_RECENT_SEARCH_LIST
    );
  }

  //request for getting recent request id data
  getPriceCompareDetailsById() {
    return (
      this.getAPIDomain() + domainResources.GET_PRICE_COMPARE_DETAILS_BY_ID
    );
  }

  //delete recent request by requestId
  deleteRecentRequestById() {
    return this.getAPIDomain() + domainResources.DELETE_RECENT_REQUEST_BY_ID;
  }

  //request facility details
  getFacilityDetails() {
    return this.getAPIDomain() + domainResources.GET_FACILITY_DETAILS;
  }
  //request facility address details
  getClaimsAddressDetails() {
    return this.getAPIDomain() + domainResources.GET_CLAIMS_ADDRESS;
  }

  //get client configuration details
  getClientConfiguration() {
    return this.getAPIDomain() + domainResources.GET_CLIENT_CONFIG_RESOURCE;
  }

  getMemberCoverageNetwork() {
    this.membercoveragenetwork = domainResources.MEMBER_COVERAGE_NETWORK;
    return this.getAPIDomain() + this.membercoveragenetwork;
  }

  //get benefits availed details
  getBenefitsAvailed() {
    return this.getAPIDomain() + domainResources.BENEFITS_AVAILED;
  }

  //get benefits availed details
  getCoveredServiceWaitingPeriod() {
    return (
      this.getAPIDomain() + domainResources.COVERED_SERVICES_WAITING_PERIOD
    );
  }
  //Find Provider Address Set
  findProviderAddressSet(userAddress) {
    return (
      this.getAPIDomain() +
      `/provider/useraddress/useraddress/${userAddress}/maximumradius/20`
    );
  }

  //Post form data for document upload
  postFormDataUploadDocument() {
    return this.getAPIDomain() + domainResources.POST_UPLOAD_DOCUMENT_FORM_DATA;
  }

  //Post form data for document upload
  postFileDataUploadDocument() {
    return this.getAPIDomain() + domainResources.POST_UPLOAD_DOCUMENT_FILE_DATA;
  }

  getDocumentUploadList() {
    return this.getAPIDomain() + domainResources.GET_DOCUMENT_UPLOADS;
  }

  getDocumentsDetail() {
    return this.getAPIDomain() + domainResources.GET_DOCUMENT_DETAILS;
  }

  //Download single document
  getDocumentsDownload() {
    return this.getAPIDomain() + domainResources.GET_DOCUMENT_DOWNLOAD;
  }
  //Download zip document
  getAllDocumentsDownload() {
    return this.getAPIDomain() + domainResources.GET_ALL_DOCUMENT_DOWNLOAD;
  }

  //document type list
  getDocumentTypeList() {
    return this.getAPIDomain() + domainResources.GET_DOCUMENT_TYPE_LIST;
  }

  getAppConfigs() {
    return this.getAPIDomain() + domainResources.GET_APP_CONFIGS;
  }

  //get notification count api
  getNotificationcountapi() {
    return this.getAPIDomain() + domainResources.NOTIFICATION_POPUP_COUNT;
  }

  //get send receive message api
  getSendReceiveMessage() {
    return this.getAPIDomain() + domainResources.SEND_RECEIVE_MESSAGE;
  }
  updateMemberEOBPreferences(loggedInMemberType) {
    if (loggedInMemberType === 'Employee') {
      this.updateEOBPreference = domainResources.UPDATE_EOB_PREFERENCE;
    } else {
      this.updateEOBPreference =
        domainResources.UPDATE_EOB_PREFERENCE_DEPENDENT;
    }

    return this.getAPIDomain() + this.updateEOBPreference;
  }
  //get type category list api
  getTypeCategoryList() {
    return this.getAPIDomain() + domainResources.GET_TYPE_CATEGORY_MESSAGE;
  }
  composeMessageResource() {
    return this.getAPIDomain() + domainResources.COMPOSE_MESSAGE;
  }
  searchFacilitiespricecompare() {
    return this.getAPIDomain() + domainResources.SEARCH_FACILITIES_PRICECOMPARE;
  }
  //mark message as READ
  markMessageIsRead() {
    return this.getAPIDomain() + domainResources.MARK_MESSAGE_ISREAD;
  }
  getClaimsDocumentList() {
    return this.getAPIDomain() + domainResources.GET_CLAIMS_DOCUMENTS;
  }

  //get zaki point service codes
  getZakiPointProcedureCode() {
    return this.getAPIDomain() + domainResources.GET_ZAKIPOINT_PROCEDURE_CODES;
  }

  //get client email configuration
  getClientEmailConfiguration() {
    this.CLIENT_EMAIL_CONFIG = domainResources.CLIENT_EMAIL_CONFIG;
    return this.getAPIDomain() + this.CLIENT_EMAIL_CONFIG;
  }

  //Dual coverage add multi user
  addMultiUserResource() {
    return this.getAPIDomain() + domainResources.ADD_MULTI_USER_API_RESOURCE;
  }

  //Dual coverage mail link validation
  validateDualCoverageLink() {
    return (
      this.getAPIDomain() +
      domainResources.DUAL_COVERAGE_REGISTRATION_LINK_VALIDATION
    );
  }
  getTalonAuthToken() {
    return this.getAPIDomain() + domainResources.GET_TALON_AUTH_TOKEN;
  }
  restPasswordLinkValidation() {
    return this.getAPIDomain() + domainResources.RESET_PASSWORD_LINK_VALIDATION;
  }
  meberOrDependentRegistration() {
    return (
      this.getAPIDomain() + domainResources.MEMBER_OR_DEPENDENT_REGISTRATION
    );
  }
  registrationLinkValidation() {
    return (
      this.getAPIDomain() + domainResources.VALIDATE_EMAIL_LINK_REGISTRATION
    );
  }
  getUserAvailability() {
    return this.getAPIDomain() + domainResources.GET_USER_AVAILABILITY;
  }
  postSelfAccountVerification() {
    return this.getAPIDomain() + domainResources.POST_SELF_ACCOUNT_VERIFICATION;
  }
  getSelfAccountLinkVerification() {
    return (
      this.getAPIDomain() + domainResources.GET_SELF_ACCOUNT_LINK_VERIFICATION
    );
  }
}
export default new APIEndpoints();
